<template>
  <div class="full-container-page display-col full-height">
    <div class="lx-flex-shrink-0 lx-flex-row-between" v-if="showBreadCrumb=='1'&&canReturn=='0'">
      <BreadCrumb />
      <div style="margin-bottom:10px">
        <a target="_blank"
           href="https://oytqc-oss.oss-cn-qingdao.aliyuncs.com/zhaoke/yuzaiko/%E5%9B%BD%E9%9A%9B%E9%80%81%E6%96%99202406.%E6%9B%B4%E6%96%B0.docx"
           style="margin-right:20px">{{$t('excel.excel15')}}</a>
        <a target="_blank"
           href="https://oytqc-oss.oss-cn-qingdao.aliyuncs.com/zhaoke/yuzaiko/昭可贸易检品收费标准2024.docx"
           style="margin-right:20px">{{$t('excel.excel16')}}</a>
        <a target="_blank"
           href="https://oytqc-oss.oss-cn-qingdao.aliyuncs.com/zhaoke/yuzaiko/充值送金活动.docx">{{$t('excel.excel17')}}</a>
      </div>
    </div>

    <div class="breadcrumb-container editBread-container" v-if="showBreadCrumb=='1'&&canReturn=='1'">
      <slot name="editBreadcrumb"></slot>
    </div>
    <div class="full-container lx-flex-grow-1" :class="{hidden: isHidden}">
      <slot name="full"></slot>
    </div>
  </div>
</template>

<script>
import BreadCrumb from './layout/components/breadCrumb'
export default {
  data () {
    return {

    }
  },
  components: { BreadCrumb },
  props: {
    canReturn: {
      default: '0'
    },
    showBreadCrumb: {
      default: '1'
    },
    isHidden: {
      type: Boolean,
      default: false
    }
  },
  methods: {

  },
  created () {
  }
};
</script>

<style lang="less" scoped>
a {
  color: black;
  text-decoration: none;
}
.full-container-page {
  overflow: auto;
}
.editBread-container {
  padding-bottom: 10px;
}
.full-container {
  // margin-top: 10px;
  padding: 10px;
  // overflow: hidden;
  background-color: #fff;
  border-radius: 5px;
}
.full-container.hidden {
  overflow: hidden;
}
.breadcrumb {
  display: flex;
  justify-content: space-between;
}
</style>
